(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-discussion-article-content"]) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-community-article-carousel]');
    if (!carousels.length) return;

    carousels.forEach((carousel) => {
      const viewport = carousel.querySelector('[data-carousel-viewport]');
      const track = carousel.querySelector('[data-carousel-track]');
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      const dots = carousel.querySelectorAll('[data-carousel-dot]');
      const imageTriggers = carousel.querySelectorAll('[data-carousel-image-trigger]');
      const lightbox = carousel.querySelector('[data-carousel-lightbox]');
      const lightboxStage = carousel.querySelector('[data-lightbox-stage]');
      const lightboxImage = carousel.querySelector('[data-lightbox-image]');
      const lightboxClose = carousel.querySelector('[data-lightbox-close]');
      const lightboxPrev = carousel.querySelector('[data-lightbox-prev]');
      const lightboxNext = carousel.querySelector('[data-lightbox-next]');
      const zoomInBtn = carousel.querySelector('[data-lightbox-zoom-in]');
      const zoomOutBtn = carousel.querySelector('[data-lightbox-zoom-out]');
      const resetBtn = carousel.querySelector('[data-lightbox-reset]');
      if (!viewport || !track || !prevBtn || !nextBtn) return;

      const slides = track.querySelectorAll('[data-carousel-slide]');
      const total = slides.length;
      if (!total) return;
      const lightboxSources = Array.from(imageTriggers).map((trigger) => ({
        src: trigger.dataset.fullSrc || '',
        alt: trigger.dataset.alt || ''
      }));
      const lightboxState = {
        active: false,
        index: 0,
        scale: 1,
        x: 0,
        y: 0,
        dragging: false,
        pointerId: null,
        startX: 0,
        startY: 0,
        startOffsetX: 0,
        startOffsetY: 0
      };

      const getIndex = () => {
        const width = viewport.clientWidth || 1;
        return Math.round(viewport.scrollLeft / width);
      };

      const clampIndex = (index) => Math.max(0, Math.min(total - 1, index));

      const update = () => {
        const index = clampIndex(getIndex());
        prevBtn.disabled = index <= 0;
        nextBtn.disabled = index >= total - 1;
        dots.forEach((dot) => {
          const dotIndex = Number(dot.dataset.index || 0);
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const goTo = (index) => {
        const nextIndex = clampIndex(index);
        viewport.scrollTo({ left: viewport.clientWidth * nextIndex, behavior: 'smooth' });
      };

      const clampOffset = () => {
        if (!lightboxStage || !lightboxImage) return;
        const stageRect = lightboxStage.getBoundingClientRect();
        const naturalWidth = lightboxImage.naturalWidth || 1;
        const naturalHeight = lightboxImage.naturalHeight || 1;
        const fitScale = Math.min(stageRect.width / naturalWidth, stageRect.height / naturalHeight);
        const baseWidth = naturalWidth * fitScale;
        const baseHeight = naturalHeight * fitScale;
        const scaledWidth = baseWidth * lightboxState.scale;
        const scaledHeight = baseHeight * lightboxState.scale;
        const maxX = Math.max(0, (scaledWidth - stageRect.width) / 2);
        const maxY = Math.max(0, (scaledHeight - stageRect.height) / 2);
        lightboxState.x = Math.max(-maxX, Math.min(maxX, lightboxState.x));
        lightboxState.y = Math.max(-maxY, Math.min(maxY, lightboxState.y));
      };

      const applyTransform = () => {
        if (!lightboxImage) return;
        clampOffset();
        lightboxImage.style.transform = `translate(${lightboxState.x}px, ${lightboxState.y}px) scale(${lightboxState.scale})`;
      };

      const setScale = (scale) => {
        lightboxState.scale = Math.max(1, Math.min(4, scale));
        if (lightboxState.scale === 1) {
          lightboxState.x = 0;
          lightboxState.y = 0;
        }
        applyTransform();
      };

      const setLightboxImage = (index) => {
        if (!lightboxImage || !lightboxSources.length) return;
        const safeIndex = ((index % lightboxSources.length) + lightboxSources.length) % lightboxSources.length;
        lightboxState.index = safeIndex;
        const source = lightboxSources[safeIndex];
        lightboxImage.src = source.src;
        lightboxImage.alt = source.alt;
        lightboxState.scale = 1;
        lightboxState.x = 0;
        lightboxState.y = 0;
        lightboxImage.onload = () => applyTransform();
      };

      const openLightbox = (index) => {
        if (!lightbox || !lightboxImage || !lightboxSources.length) return;
        setLightboxImage(index);
        lightbox.hidden = false;
        lightboxState.active = true;
        document.documentElement.style.overflow = 'hidden';
      };

      const closeLightbox = () => {
        if (!lightbox) return;
        lightbox.hidden = true;
        lightboxState.active = false;
        lightboxState.dragging = false;
        lightboxStage?.classList.remove('is-dragging');
        document.documentElement.style.overflow = '';
      };

      prevBtn.addEventListener('click', () => goTo(getIndex() - 1));
      nextBtn.addEventListener('click', () => goTo(getIndex() + 1));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const targetIndex = Number(dot.dataset.index || 0);
          goTo(targetIndex);
        });
      });
      viewport.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(getIndex() - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(getIndex() + 1);
        }
      });
      imageTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const index = Number(trigger.dataset.index || 0);
          openLightbox(index);
        });
      });
      lightboxClose?.addEventListener('click', closeLightbox);
      lightboxPrev?.addEventListener('click', () => setLightboxImage(lightboxState.index - 1));
      lightboxNext?.addEventListener('click', () => setLightboxImage(lightboxState.index + 1));
      zoomInBtn?.addEventListener('click', () => setScale(lightboxState.scale + 0.25));
      zoomOutBtn?.addEventListener('click', () => setScale(lightboxState.scale - 0.25));
      resetBtn?.addEventListener('click', () => setScale(1));

      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });

      lightboxStage?.addEventListener(
        'wheel',
        (event) => {
          event.preventDefault();
          const zoomDelta = event.deltaY < 0 ? 0.2 : -0.2;
          setScale(lightboxState.scale + zoomDelta);
        },
        { passive: false }
      );
      lightboxStage?.addEventListener('pointerdown', (event) => {
        if (lightboxState.scale <= 1) return;
        lightboxState.dragging = true;
        lightboxState.pointerId = event.pointerId;
        lightboxState.startX = event.clientX;
        lightboxState.startY = event.clientY;
        lightboxState.startOffsetX = lightboxState.x;
        lightboxState.startOffsetY = lightboxState.y;
        lightboxStage.classList.add('is-dragging');
        lightboxStage.setPointerCapture(event.pointerId);
      });
      lightboxStage?.addEventListener('pointermove', (event) => {
        if (!lightboxState.dragging || event.pointerId !== lightboxState.pointerId) return;
        const deltaX = event.clientX - lightboxState.startX;
        const deltaY = event.clientY - lightboxState.startY;
        lightboxState.x = lightboxState.startOffsetX + deltaX;
        lightboxState.y = lightboxState.startOffsetY + deltaY;
        applyTransform();
      });
      const stopDragging = () => {
        lightboxState.dragging = false;
        lightboxState.pointerId = null;
        lightboxStage?.classList.remove('is-dragging');
      };
      lightboxStage?.addEventListener('pointerup', stopDragging);
      lightboxStage?.addEventListener('pointercancel', stopDragging);
      lightboxStage?.addEventListener('dblclick', () => {
        if (lightboxState.scale > 1) {
          setScale(1);
          return;
        }
        setScale(2);
      });

      window.addEventListener('keydown', (event) => {
        if (!lightboxState.active) return;
        if (event.key === 'Escape') {
          closeLightbox();
        }
        if (event.key === 'ArrowLeft') {
          setLightboxImage(lightboxState.index - 1);
        }
        if (event.key === 'ArrowRight') {
          setLightboxImage(lightboxState.index + 1);
        }
        if (event.key === '+' || event.key === '=') {
          setScale(lightboxState.scale + 0.25);
        }
        if (event.key === '-' || event.key === '_') {
          setScale(lightboxState.scale - 0.25);
        }
      });

      new ResizeObserver(update).observe(viewport);
      new ResizeObserver(() => {
        if (lightboxState.active) applyTransform();
      }).observe(document.body);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goddess-space-audio-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-goddess-audio-grid]');
    if (!sections.length) return;

    sections.forEach((section) => {
      if (section.dataset.goddessAudioGridReady === 'true') return;
      section.dataset.goddessAudioGridReady = 'true';

      const filterButtons = section.querySelectorAll('[data-filter-value]');
      const cards = section.querySelectorAll('[data-audio-card]');
      const audio = section.querySelector('[data-audio-player]');
      const browseView = section.querySelector('[data-view="grid"]');
      const playerView = section.querySelector('[data-view="player"]');
      const backButton = section.querySelector('[data-audio-back]');
      const playerImage = section.querySelector('[data-player-image]');
      const playerTitle = section.querySelector('[data-player-title]');
      const playerCategory = section.querySelector('[data-player-category]');
      const playerDescription = section.querySelector('[data-player-description]');
      const productPanel = section.querySelector('[data-product-panel]');
      const tabButtons = section.querySelectorAll('[data-tab]');
      const tabPanels = section.querySelectorAll('[data-panel]');
      const playBtn = section.querySelector('[data-action="play"]');
      const skipBackBtn = section.querySelector('[data-action="skip-back"]');
      const skipForwardBtn = section.querySelector('[data-action="skip-forward"]');
      const speedBtn = section.querySelector('[data-action="speed"]');
      const progressBar = section.querySelector('[data-progress]');
      const currentTimeEl = section.querySelector('[data-current-time]');
      const totalTimeEl = section.querySelector('[data-total-time]');
      const vipModal = document.getElementById(section.dataset.vipModalId || '');
      const vipModalCloseBtn = document.getElementById(section.dataset.vipModalCloseId || '');
      const loginModal = document.getElementById(section.dataset.loginModalId || '');
      const loginModalCloseBtn = document.getElementById(section.dataset.loginModalCloseId || '');
      if (!audio) return;

      const isLoggedIn = section.dataset.isLoggedIn === 'true';
      const speeds = [1, 1.5, 2];
      let currentSpeed = 1;
      
      const showVipModal = () => {
        if (!vipModal) return;
        vipModal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      };

      const showLoginModal = () => {
        if (!loginModal) return;
        loginModal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      };

      const hideVipModal = () => {
        if (!vipModal) return;
        vipModal.style.display = 'none';
        document.body.style.overflow = '';
      };

      const hideLoginModal = () => {
        if (!loginModal) return;
        loginModal.style.display = 'none';
        document.body.style.overflow = '';
      };

      const handleLockedAudio = () => {
        if (!isLoggedIn) {
          showLoginModal();
          return;
        }
        showVipModal();
      };

      const stopCurrent = () => {
        audio.pause();
        audio.currentTime = 0;
      };

      const formatTime = (seconds) => {
        if (!Number.isFinite(seconds) || seconds < 0) return '00:00';
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      };

      const updatePlayUi = () => {
        if (!playBtn) return;
        const playIcon = playBtn.querySelector('.play-icon');
        const pauseIcon = playBtn.querySelector('.pause-icon');
        const playing = !audio.paused;
        playBtn.classList.toggle('is-playing', playing);
        if (playIcon) {
          playIcon.classList.toggle('hidden', playing);
          playIcon.hidden = playing;
        }
        if (pauseIcon) {
          pauseIcon.classList.toggle('hidden', !playing);
          pauseIcon.hidden = !playing;
        }
        playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      };

      const setTab = (tabName) => {
        tabButtons.forEach((btn) => {
          const active = btn.dataset.tab === tabName;
          btn.classList.toggle('active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        tabPanels.forEach((panel) => {
          const active = panel.dataset.panel === tabName;
          panel.classList.toggle('active', active);
          panel.hidden = !active;
        });
      };

      const updateFilter = (value) => {
        cards.forEach((card) => {
          const cardCategory = (card.dataset.category || '').toLowerCase();
          const visible = value === 'all' || cardCategory === value;
          card.classList.toggle('is-hidden', !visible);
        });
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = (button.dataset.filterValue || 'all').toLowerCase();
          filterButtons.forEach((item) => {
            const isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          updateFilter(value);
        });
      });

      const openPlayerFromCard = (card) => {
        const audioUrl = card.dataset.audioUrl || '';
        if (!audioUrl) return;

        if (playerTitle) playerTitle.textContent = card.dataset.title || '';
        if (playerCategory) playerCategory.textContent = card.dataset.categoryLabel || '';
        if (playerImage) {
          const imageUrl = card.dataset.imageUrl || '';
          playerImage.style.backgroundImage = imageUrl ? `url("${imageUrl}")` : 'none';
          playerImage.setAttribute('aria-label', card.dataset.title || '');
        }
        if (playerDescription) {
          const template = card.querySelector('[data-audio-description-template]');
          playerDescription.innerHTML = template ? template.innerHTML : '';
        }
        if (productPanel) {
          const productTemplate = card.querySelector('[data-product-template]');
          productPanel.innerHTML = productTemplate ? productTemplate.innerHTML : '';
        }

        audio.src = audioUrl;
        audio.currentTime = 0;
        audio.playbackRate = currentSpeed;
        if (speedBtn) speedBtn.textContent = `${currentSpeed}x`;
        audio.play().catch(() => {});
        updatePlayUi();
        setTab('audio');

        if (browseView) browseView.hidden = true;
        if (playerView) playerView.hidden = false;
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const closePlayer = () => {
        stopCurrent();
        updatePlayUi();
        setTab('audio');
        if (playerView) playerView.hidden = true;
        if (browseView) browseView.hidden = false;
      };

      section.addEventListener('click', (event) => {
        const button = event.target.closest('[data-audio-play]');
        if (button && !button.disabled) {
          const card = button.closest('[data-audio-card]');
          if (!card) return;
          if (card.dataset.audioLocked === 'true') {
            handleLockedAudio();
            return;
          }
          openPlayerFromCard(card);
          return;
        }

        const card = event.target.closest('[data-audio-card]');
        if (!card) return;

        if (card.dataset.audioLocked === 'true') {
          handleLockedAudio();
          return;
        }
        openPlayerFromCard(card);
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('[data-audio-card]');
        if (!card) return;
        event.preventDefault();
        if (card.dataset.audioLocked === 'true') {
          handleLockedAudio();
          return;
        }
        openPlayerFromCard(card);
      });

      backButton?.addEventListener('click', closePlayer);
      tabButtons.forEach((btn) => {
        btn.addEventListener('click', () => setTab(btn.dataset.tab || 'audio'));
      });

      playBtn?.addEventListener('click', () => {
        if (!audio.src) return;
        if (audio.paused) {
          audio.play().catch(() => {});
        } else {
          audio.pause();
        }
      });

      skipBackBtn?.addEventListener('click', () => {
        audio.currentTime = Math.max(0, (audio.currentTime || 0) - 10);
      });

      skipForwardBtn?.addEventListener('click', () => {
        const duration = audio.duration || 0;
        audio.currentTime = Math.min(duration, (audio.currentTime || 0) + 10);
      });

      speedBtn?.addEventListener('click', () => {
        const currentIndex = speeds.indexOf(currentSpeed);
        const nextIndex = (currentIndex + 1) % speeds.length;
        currentSpeed = speeds[nextIndex];
        audio.playbackRate = currentSpeed;
        speedBtn.textContent = `${currentSpeed}x`;
      });

      progressBar?.addEventListener('input', () => {
        audio.currentTime = Number(progressBar.value || 0);
      });

      audio.addEventListener('loadedmetadata', () => {
        if (totalTimeEl) totalTimeEl.textContent = formatTime(audio.duration);
        if (progressBar) progressBar.max = String(Math.floor(audio.duration || 0));
      });

      audio.addEventListener('timeupdate', () => {
        if (currentTimeEl) currentTimeEl.textContent = formatTime(audio.currentTime);
        if (progressBar) progressBar.value = String(Math.floor(audio.currentTime || 0));
      });

      audio.addEventListener('play', updatePlayUi);
      audio.addEventListener('pause', updatePlayUi);
      audio.addEventListener('ended', updatePlayUi);
      updatePlayUi();

      vipModalCloseBtn?.addEventListener('click', hideVipModal);
      loginModalCloseBtn?.addEventListener('click', hideLoginModal);
      if (vipModal) {
        vipModal.addEventListener('click', (event) => {
          if (event.target === vipModal || event.target.classList.contains('modal-popup__overlay')) {
            hideVipModal();
          }
        });
      }
      if (loginModal) {
        loginModal.addEventListener('click', (event) => {
          if (event.target === loginModal || event.target.classList.contains('modal-popup__overlay')) {
            hideLoginModal();
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goddess-space-audio-section"] && !Shopify.designMode) return;
  try {
    
  const formatTime = (seconds) => {
    if (!Number.isFinite(seconds) || seconds < 0) return '00:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const initGoddessAudioSection = (sectionEl) => {
    if (!sectionEl || sectionEl.dataset.goddessAudioInitialized === 'true') return;
    sectionEl.dataset.goddessAudioInitialized = 'true';

    const cardsView = sectionEl.querySelector('[data-view="cards"]');
    const playerView = sectionEl.querySelector('[data-view="player"]');
    const cardsScroll = sectionEl.querySelector('[data-cards-scroll]');
    const scrollIndicator = sectionEl.querySelector('[data-scroll-indicator]');
    const scrollThumb = sectionEl.querySelector('[data-scroll-thumb]');
    const audio = sectionEl.querySelector('[data-audio]');
    const prevScrollBtn = sectionEl.querySelector('[data-audio-scroll-prev]');
    const nextScrollBtn = sectionEl.querySelector('[data-audio-scroll-next]');

    const backBtn = sectionEl.querySelector('[data-action="back"]');
    const playBtn = sectionEl.querySelector('[data-action="play"]');
    const speedBtn = sectionEl.querySelector('[data-action="speed"]');
    const skipBackBtn = sectionEl.querySelector('[data-action="skip-back"]');
    const skipForwardBtn = sectionEl.querySelector('[data-action="skip-forward"]');
    const vipModal = document.getElementById(sectionEl.dataset.vipModalId || '');
    const vipModalCloseBtn = document.getElementById(sectionEl.dataset.vipModalCloseId || '');
    const loginModal = document.getElementById(sectionEl.dataset.loginModalId || '');
    const loginModalCloseBtn = document.getElementById(sectionEl.dataset.loginModalCloseId || '');

    const progressBar = sectionEl.querySelector('[data-progress]');
    const currentTimeEl = sectionEl.querySelector('[data-current-time]');
    const totalTimeEl = sectionEl.querySelector('[data-total-time]');
    const playerImg = sectionEl.querySelector('[data-player-image] .ib__img');
    const audioTitleEl = sectionEl.querySelector('[data-audio-title]');
    const audioCategoryEl = sectionEl.querySelector('[data-audio-category]');
    const audioDescriptionEl = sectionEl.querySelector('[data-audio-description]');

    const tabButtons = Array.from(sectionEl.querySelectorAll('[data-tab]'));
    const panels = {
      audio: sectionEl.querySelector('[data-panel="audio"]'),
      product: sectionEl.querySelector('[data-panel="product"]')
    };
    const productPanel = sectionEl.querySelector('[data-product-panel]');

    if (!cardsView || !playerView || !cardsScroll || !audio) return;

    let currentSpeed = 1;
    const speeds = [0.75, 1, 1.25, 1.5, 2];
    const isLoggedIn = sectionEl.dataset.isLoggedIn === 'true';
    
    const showVipModal = () => {
      if (!vipModal) return;
      vipModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    };

    const showLoginModal = () => {
      if (!loginModal) return;
      loginModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    };

    const hideVipModal = () => {
      if (!vipModal) return;
      vipModal.style.display = 'none';
      document.body.style.overflow = '';
    };

    const hideLoginModal = () => {
      if (!loginModal) return;
      loginModal.style.display = 'none';
      document.body.style.overflow = '';
    };

    const handleLockedAudio = () => {
      if (!isLoggedIn) {
        showLoginModal();
        return;
      }
      showVipModal();
    };

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let isPointerDown = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let lastPointerX = 0;
    let lastPointerY = 0;
    let dragStartScrollLeft = 0;
    let didDrag = false;
    let suppressNextClick = false;
    let activePointerId = null;
    let pendingScrollLeft = 0;
    let rafId = 0;
    let restoreSnapTimeoutId = 0;

    const getScrollStep = () => {
      const card = cardsScroll.querySelector('[data-audio-card]');
      if (!card) return Math.max(240, cardsScroll.clientWidth * 0.85);
      const styles = getComputedStyle(cardsScroll);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return Math.ceil(card.getBoundingClientRect().width + gap);
    };

    const updateScrollButtons = () => {
      if (!prevScrollBtn || !nextScrollBtn) return;
      const maxScrollLeft = cardsScroll.scrollWidth - cardsScroll.clientWidth;
      const hasOverflow = maxScrollLeft > 2;
      prevScrollBtn.disabled = !hasOverflow || cardsScroll.scrollLeft <= 2;
      nextScrollBtn.disabled = !hasOverflow || cardsScroll.scrollLeft >= maxScrollLeft - 2;
    };

    const scheduleSnapRestore = () => {
      if (restoreSnapTimeoutId) window.clearTimeout(restoreSnapTimeoutId);
      restoreSnapTimeoutId = window.setTimeout(() => {
        cardsScroll.toggleAttribute('data-goddess-audio-dragging', false);
        restoreSnapTimeoutId = 0;
      }, prefersReducedMotion ? 0 : 180);
    };

    const snapToNearestCard = () => {
      const cards = cardsScroll.querySelectorAll('[data-audio-card]');
      if (!cards.length) return;

      const viewportRect = cardsScroll.getBoundingClientRect();
      const currentLeft = cardsScroll.scrollLeft;

      const getCardScrollLeft = (card) => {
        const rect = card.getBoundingClientRect();
        return rect.left - viewportRect.left + cardsScroll.scrollLeft;
      };

      let closestLeft = getCardScrollLeft(cards[0]);
      let closestDistance = Math.abs(closestLeft - currentLeft);

      cards.forEach((card) => {
        const left = getCardScrollLeft(card);
        const distance = Math.abs(left - currentLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestLeft = left;
        }
      });

      cardsScroll.scrollTo({ left: closestLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    };

    const setTab = (nextTab) => {
      tabButtons.forEach((btn) => {
        const isActive = btn.dataset.tab === nextTab;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      Object.entries(panels).forEach(([key, panel]) => {
        if (!panel) return;
        panel.classList.toggle('active', key === nextTab);
      });
    };

    const updatePlayIcon = () => {
      const playIcon = playBtn?.querySelector('.play-icon');
      const pauseIcon = playBtn?.querySelector('.pause-icon');
      if (!playIcon || !pauseIcon) return;
      const isPlaying = !audio.paused;
      playIcon.classList.toggle('hidden', isPlaying);
      pauseIcon.classList.toggle('hidden', !isPlaying);
    };

    const resetPlayer = () => {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
      if (progressBar) progressBar.value = 0;
      if (progressBar) progressBar.max = 100;
      if (currentTimeEl) currentTimeEl.textContent = '00:00';
      if (totalTimeEl) totalTimeEl.textContent = '00:00';
      if (audioTitleEl) audioTitleEl.textContent = '';
      if (audioCategoryEl) audioCategoryEl.textContent = '';
      if (audioDescriptionEl) audioDescriptionEl.innerHTML = '';
      if (playerImg) {
        playerImg.removeAttribute('src');
        playerImg.alt = '';
      }
      if (productPanel) productPanel.innerHTML = '';
      updatePlayIcon();
    };

    const openPlayerFromCard = (card) => {
      if (!card) return;
      if (card.dataset.audioLocked === 'true') {
        handleLockedAudio();
        return;
      }

      const audioUrl = card.dataset.audioUrl || '';
      const title = card.dataset.title || '';
      const category = card.dataset.category || '';

      if (audioTitleEl) audioTitleEl.textContent = title;
      if (audioCategoryEl) audioCategoryEl.textContent = category;

      const cardImg = card.querySelector('.goddess-card-image .ib__img');
      if (playerImg && cardImg?.currentSrc) {
        playerImg.src = cardImg.currentSrc;
        playerImg.alt = title;
      }

      if (audioUrl) {
        audio.src = audioUrl;
        audio.load();
      } else {
        audio.removeAttribute('src');
        audio.load();
      }

      const tpl = card.querySelector('template[data-product-template]');
      if (productPanel) productPanel.innerHTML = tpl ? tpl.innerHTML : '';

      const descriptionTpl = card.querySelector('template[data-audio-description-template]');
      if (audioDescriptionEl) audioDescriptionEl.innerHTML = descriptionTpl ? descriptionTpl.innerHTML : '';

      cardsView.classList.add('hidden');
      playerView.classList.remove('hidden');
      setTab('audio');

      if (audioUrl) {
        audio.play().then(updatePlayIcon).catch(() => updatePlayIcon());
      } else {
        updatePlayIcon();
      }
    };

    const closePlayer = () => {
      resetPlayer();
      cardsView.classList.remove('hidden');
      playerView.classList.add('hidden');
    };

      const updateScrollIndicator = () => {
        if (!scrollThumb || !scrollIndicator) return;
      const scrollWidth = cardsScroll.scrollWidth;
      const clientWidth = cardsScroll.clientWidth;
      const scrollLeft = cardsScroll.scrollLeft;

      const canScroll = scrollWidth > clientWidth + 1;
      scrollIndicator.hidden = !canScroll;
      if (!canScroll) return;

      const thumbWidth = (clientWidth / scrollWidth) * 100;
      const thumbLeft = (scrollLeft / (scrollWidth - clientWidth)) * (100 - thumbWidth);

      scrollThumb.style.width = `${thumbWidth}%`;
      scrollThumb.style.left = `${thumbLeft}%`;
    };

    const handleCardsScroll = () => {
      updateScrollIndicator();
      updateScrollButtons();
      if (!isPointerDown && cardsScroll.hasAttribute('data-goddess-audio-dragging')) {
        scheduleSnapRestore();
      }
    };

    cardsScroll.addEventListener('scroll', handleCardsScroll, { passive: true });

    const resizeObserver = new ResizeObserver(() => handleCardsScroll());
    resizeObserver.observe(cardsScroll);

    prevScrollBtn?.addEventListener('click', () => {
      cardsScroll.scrollBy({ left: -getScrollStep(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });
    nextScrollBtn?.addEventListener('click', () => {
      cardsScroll.scrollBy({ left: getScrollStep(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });

    cardsScroll.addEventListener('dragstart', (event) => event.preventDefault());

    const onPointerDown = (event) => {
      if (event.pointerType !== 'mouse') return;
      if (event.button !== 0) return;

      if (restoreSnapTimeoutId) {
        window.clearTimeout(restoreSnapTimeoutId);
        restoreSnapTimeoutId = 0;
      }

      isPointerDown = true;
      didDrag = false;
      suppressNextClick = false;
      activePointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      lastPointerX = event.clientX;
      lastPointerY = event.clientY;
      dragStartScrollLeft = cardsScroll.scrollLeft;
      pendingScrollLeft = dragStartScrollLeft;
    };

    const onPointerMove = (event) => {
      if (!isPointerDown) return;
      if (event.pointerType !== 'mouse') return;

      const deltaX = event.clientX - dragStartX;
      const deltaY = event.clientY - dragStartY;
      lastPointerX = event.clientX;
      lastPointerY = event.clientY;

      if (!didDrag && Math.abs(deltaX) > 16 && Math.abs(deltaX) > Math.abs(deltaY) + 6) {
        didDrag = true;
        cardsScroll.toggleAttribute('data-goddess-audio-dragging', true);
        if (activePointerId != null) {
          try {
            cardsScroll.setPointerCapture(activePointerId);
          } catch {
            // noop
          }
        }
      }
      if (!didDrag) return;

      event.preventDefault();
      pendingScrollLeft = dragStartScrollLeft - deltaX;
      if (rafId) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = 0;
        cardsScroll.scrollLeft = pendingScrollLeft;
      });
    };

    const onPointerUpOrCancel = () => {
      isPointerDown = false;

      if (activePointerId != null) {
        try {
          cardsScroll.releasePointerCapture(activePointerId);
        } catch {
          // noop
        }
      }
      activePointerId = null;

      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      }

      if (didDrag) {
        snapToNearestCard();
        scheduleSnapRestore();
      } else {
        cardsScroll.toggleAttribute('data-goddess-audio-dragging', false);
      }

      const totalDeltaX = lastPointerX - dragStartX;
      const totalDeltaY = lastPointerY - dragStartY;
      suppressNextClick = Math.abs(totalDeltaX) > 10 && Math.abs(totalDeltaX) > Math.abs(totalDeltaY) + 6;

      didDrag = false;
    };

    cardsScroll.addEventListener('pointerdown', onPointerDown);
    cardsScroll.addEventListener('pointermove', onPointerMove);
    cardsScroll.addEventListener('pointerup', onPointerUpOrCancel);
    cardsScroll.addEventListener('pointercancel', onPointerUpOrCancel);

    cardsView.addEventListener(
      'click',
      (event) => {
        if (!suppressNextClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressNextClick = false;
      },
      true
    );

    handleCardsScroll();

    cardsView.addEventListener('click', (event) => {
      const target = event.target;
      const card = target.closest('[data-audio-card]');
      if (!card) return;

      const actionEl = target.closest('[data-action]');
      const action = actionEl?.dataset.action;

      if (action === 'open') {
        if (card.dataset.audioLocked === 'true') {
          event.preventDefault();
          handleLockedAudio();
          return;
        }
        openPlayerFromCard(card);
      }
    });

    cardsView.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const card = event.target.closest('[data-audio-card]');
      const openBtn = event.target.closest('[data-action="open"]');
      if (!card || !openBtn) return;
      event.preventDefault();
      if (card.dataset.audioLocked === 'true') {
        handleLockedAudio();
        return;
      }
      openPlayerFromCard(card);
    });

    vipModalCloseBtn?.addEventListener('click', hideVipModal);
    loginModalCloseBtn?.addEventListener('click', hideLoginModal);
    if (vipModal) {
      vipModal.addEventListener('click', (event) => {
        if (event.target === vipModal || event.target.classList.contains('modal-popup__overlay')) {
          hideVipModal();
        }
      });
    }
    if (loginModal) {
      loginModal.addEventListener('click', (event) => {
        if (event.target === loginModal || event.target.classList.contains('modal-popup__overlay')) {
          hideLoginModal();
        }
      });
    }

      backBtn?.addEventListener('click', closePlayer);

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => setTab(btn.dataset.tab));
    });

    playBtn?.addEventListener('click', () => {
      if (!audio.src) return;
      if (audio.paused) {
        audio.play().then(updatePlayIcon).catch(() => updatePlayIcon());
      } else {
        audio.pause();
        updatePlayIcon();
      }
    });

    audio.addEventListener('loadedmetadata', () => {
      if (totalTimeEl) totalTimeEl.textContent = formatTime(audio.duration);
      if (progressBar) progressBar.max = String(Math.floor(audio.duration || 0));
    });

    audio.addEventListener('timeupdate', () => {
      if (currentTimeEl) currentTimeEl.textContent = formatTime(audio.currentTime);
      if (progressBar) progressBar.value = String(Math.floor(audio.currentTime || 0));
    });

    audio.addEventListener('ended', updatePlayIcon);
    audio.addEventListener('pause', updatePlayIcon);
    audio.addEventListener('play', updatePlayIcon);

    progressBar?.addEventListener('input', () => {
      audio.currentTime = Number(progressBar.value || 0);
    });

    skipBackBtn?.addEventListener('click', () => {
      audio.currentTime = Math.max(0, (audio.currentTime || 0) - 10);
    });

    skipForwardBtn?.addEventListener('click', () => {
      const duration = audio.duration || 0;
      audio.currentTime = Math.min(duration, (audio.currentTime || 0) + 10);
    });

    speedBtn?.addEventListener('click', () => {
      const currentIndex = speeds.indexOf(currentSpeed);
      const nextIndex = (currentIndex + 1) % speeds.length;
      currentSpeed = speeds[nextIndex];
      audio.playbackRate = currentSpeed;
      speedBtn.textContent = `${currentSpeed}x`;
    });
  };

  document.querySelectorAll('[data-goddess-audio-section]').forEach(initGoddessAudioSection);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('[data-goddess-audio-section]') || event.target;
    initGoddessAudioSection(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goddess-space-blog-posts-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.goddess-space__blog-posts-carousel');
    if (!sections.length) return;

    const init = (sectionEl) => {
      const viewport = sectionEl.querySelector('[data-gs-bpc-viewport]');
      const track = sectionEl.querySelector('[data-gs-bpc-track]');
      const prevBtn = sectionEl.querySelector('[data-gs-bpc-prev]');
      const nextBtn = sectionEl.querySelector('[data-gs-bpc-next]');
      if (!viewport || !track || !prevBtn || !nextBtn) return;

      let dragStartX = 0;
      let dragStartY = 0;
      let lastPointerX = 0;
      let lastPointerY = 0;
      let dragStartScrollLeft = 0;
      let isPointerDown = false;
      let didDrag = false;
      let suppressNextClick = false;
      let activePointerId = null;
      let rafId = 0;
      let pendingScrollLeft = 0;
      let restoreSnapTimeoutId = 0;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const getStep = () => {
        const card = track.querySelector('[data-gs-bpc-card]');
        if (!card) return Math.max(240, viewport.clientWidth * 0.85);
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
        return Math.ceil(card.getBoundingClientRect().width + gap);
      };

      const scheduleSnapRestore = () => {
        if (restoreSnapTimeoutId) window.clearTimeout(restoreSnapTimeoutId);
        restoreSnapTimeoutId = window.setTimeout(() => {
          viewport.toggleAttribute('data-gs-bpc-dragging', false);
          restoreSnapTimeoutId = 0;
        }, prefersReducedMotion ? 0 : 180);
      };

      const snapToNearest = () => {
        const cards = track.querySelectorAll('[data-gs-bpc-card]');
        if (!cards.length) return;

        const currentLeft = viewport.scrollLeft;
        const viewportRect = viewport.getBoundingClientRect();

        const getCardScrollLeft = (card) => {
          const rect = card.getBoundingClientRect();
          return rect.left - viewportRect.left + viewport.scrollLeft;
        };

        let closestLeft = getCardScrollLeft(cards[0]);
        let closestDistance = Math.abs(closestLeft - currentLeft);

        cards.forEach((card) => {
          const left = getCardScrollLeft(card);
          const distance = Math.abs(left - currentLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestLeft = left;
          }
        });

        viewport.scrollTo({ left: closestLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      };

      const update = () => {
        const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
        const hasOverflow = maxScrollLeft > 2;

        prevBtn.disabled = !hasOverflow || viewport.scrollLeft <= 2;
        nextBtn.disabled = !hasOverflow || viewport.scrollLeft >= maxScrollLeft - 2;

        sectionEl.toggleAttribute('data-gs-bpc-overflow', hasOverflow);
      };

      const scrollByStep = (dir) => {
        const step = getStep();
        viewport.scrollBy({ left: dir * step, behavior: 'smooth' });
      };

      prevBtn.addEventListener('click', () => scrollByStep(-1));
      nextBtn.addEventListener('click', () => scrollByStep(1));
      viewport.addEventListener(
        'scroll',
        () => {
          window.requestAnimationFrame(update);
          if (!isPointerDown && viewport.hasAttribute('data-gs-bpc-dragging')) {
            scheduleSnapRestore();
          }
        },
        { passive: true }
      );
      viewport.addEventListener('dragstart', (event) => event.preventDefault());

      const onPointerDown = (event) => {
        if (event.pointerType !== 'mouse') return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (restoreSnapTimeoutId) {
          window.clearTimeout(restoreSnapTimeoutId);
          restoreSnapTimeoutId = 0;
        }

        isPointerDown = true;
        didDrag = false;
        suppressNextClick = false;
        activePointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        lastPointerX = event.clientX;
        lastPointerY = event.clientY;
        dragStartScrollLeft = viewport.scrollLeft;
        pendingScrollLeft = dragStartScrollLeft;
      };

      const onPointerMove = (event) => {
        if (!isPointerDown) return;
        if (event.pointerType !== 'mouse') return;
        const deltaX = event.clientX - dragStartX;
        const deltaY = event.clientY - dragStartY;
        lastPointerX = event.clientX;
        lastPointerY = event.clientY;

        if (!didDrag && Math.abs(deltaX) > 16 && Math.abs(deltaX) > Math.abs(deltaY) + 6) {
          didDrag = true;
          viewport.toggleAttribute('data-gs-bpc-dragging', true);
          if (activePointerId != null) {
            try {
              viewport.setPointerCapture(activePointerId);
            } catch {
              // noop
            }
          }
        }
        if (!didDrag) return;
        event.preventDefault();

        pendingScrollLeft = dragStartScrollLeft - deltaX;
        if (rafId) return;
        rafId = window.requestAnimationFrame(() => {
          rafId = 0;
          viewport.scrollLeft = pendingScrollLeft;
        });
      };

      const onPointerUpOrCancel = () => {
        isPointerDown = false;
        if (activePointerId != null) {
          try {
            viewport.releasePointerCapture(activePointerId);
          } catch {
            // noop
          }
        }
        activePointerId = null;

        const totalDeltaX = lastPointerX - dragStartX;
        const totalDeltaY = lastPointerY - dragStartY;
        suppressNextClick = Math.abs(totalDeltaX) > 10 && Math.abs(totalDeltaX) > Math.abs(totalDeltaY) + 6;
        if (rafId) {
          window.cancelAnimationFrame(rafId);
          rafId = 0;
        }

        if (didDrag) {
          snapToNearest();
          scheduleSnapRestore();
        } else {
          viewport.toggleAttribute('data-gs-bpc-dragging', false);
        }

        didDrag = false;
      };

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove);
      viewport.addEventListener('pointerup', onPointerUpOrCancel);
      viewport.addEventListener('pointercancel', onPointerUpOrCancel);

      viewport.addEventListener(
        'click',
        (event) => {
          if (!suppressNextClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressNextClick = false;
        },
        true
      );

      const resizeObserver = new ResizeObserver(() => update());
      resizeObserver.observe(viewport);

      update();
    };

    sections.forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goddess-space-floating-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFloatingNav(scope) {
      var root = scope || document;
      var navs = root.querySelectorAll('[data-gs-floating-nav]');

      navs.forEach(function (nav) {
        var toggle = nav.querySelector('.gs-float-nav__toggle');
        var panel = nav.querySelector('.gs-float-nav__panel');
        if (!toggle || !panel) {
          return;
        }

        var startX = 0;
        var startY = 0;
        var startTop = 0;
        var isDragging = false;
        var moved = false;

        function clamp(value, min, max) {
          return Math.min(Math.max(value, min), max);
        }

        var lastToggleAt = 0;

        function openNav() {
          nav.classList.add('is-open');
          nav.classList.remove('gs-float-nav--interactive');
          panel.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          lastToggleAt = Date.now();
          setTimeout(function () {
            if (nav.classList.contains('is-open')) {
              nav.classList.add('gs-float-nav--interactive');
            }
          }, 140);
        }

        function closeNav() {
          nav.classList.remove('is-open');
          nav.classList.remove('gs-float-nav--interactive');
          toggle.setAttribute('aria-expanded', 'false');
          setTimeout(function () {
            if (!nav.classList.contains('is-open')) {
              panel.hidden = true;
            }
          }, 200);
          lastToggleAt = Date.now();
        }

        toggle.addEventListener('pointerdown', function (event) {
          startX = event.clientX;
          startY = event.clientY;
          startTop = nav.offsetTop;
          moved = false;
          isDragging = true;
          nav.classList.add('is-dragging');
          toggle.setPointerCapture(event.pointerId);
        });

        toggle.addEventListener('pointermove', function (event) {
          if (!isDragging) {
            return;
          }

          var deltaY = event.clientY - startY;
          var deltaX = event.clientX - startX;
          if (!moved && (Math.abs(deltaY) > 3 || Math.abs(deltaX) > 3)) {
            moved = true;
          }

          var maxTop = window.innerHeight - nav.offsetHeight;
          var nextTop = clamp(startTop + deltaY, 12, maxTop - 12);
          nav.style.top = nextTop + 'px';
        });

        toggle.addEventListener('pointerup', function () {
          if (!isDragging) {
            return;
          }

          isDragging = false;
          nav.classList.remove('is-dragging');
          if (!moved) {
            if (nav.classList.contains('is-open')) {
              closeNav();
            } else {
              openNav();
            }
          }
        });

        toggle.addEventListener('pointercancel', function () {
          isDragging = false;
          nav.classList.remove('is-dragging');
        });

        toggle.addEventListener('click', function (event) {
          event.stopPropagation();
        });

        panel.addEventListener('click', function (event) {
          event.stopPropagation();
        });

        nav.addEventListener('click', function (event) {
          var link = event.target.closest('.gs-float-nav__link');
          if (!link) {
            return;
          }
          if (Date.now() - lastToggleAt < 180) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }

          var href = (link.getAttribute('href') || '').trim();
          if (href.charAt(0) === '#') {
            event.preventDefault();
            if (window.history && window.history.pushState) {
              window.history.pushState(null, '', href);
            } else {
              window.location.hash = href;
            }
            var target = document.querySelector(href);
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
          closeNav();
        });

        document.addEventListener('click', function (event) {
          if (Date.now() - lastToggleAt < 250) {
            return;
          }
          if (!nav.contains(event.target)) {
            closeNav();
          }
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            closeNav();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initFloatingNav(document);
      });
    } else {
      initFloatingNav(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initFloatingNav(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goddess-space-icon-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initIconNav(scope) {
      var root = scope || document;
      var navs = root.querySelectorAll('.gs-icon-nav');

      navs.forEach(function (nav) {
        if (nav.dataset.gsIconNavInit === 'true') return;
        nav.dataset.gsIconNavInit = 'true';

        nav.addEventListener('click', function (event) {
          var link = event.target.closest('.gs-icon-nav__link');
          if (!link) return;

          var href = (link.getAttribute('href') || '').trim();
          if (href.charAt(0) !== '#') return;

          event.preventDefault();
          if (window.history && window.history.pushState) {
            window.history.pushState(null, '', href);
          } else {
            window.location.hash = href;
          }

          var target = document.querySelector(href);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initIconNav(document);
      });
    } else {
      initIconNav(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initIconNav(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goddess-space-main-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function loadTarotQuota(scope) {
      var root = scope || document;
      var sectionRoot = root.querySelector('#gs-main-grid');
      if (!sectionRoot || sectionRoot.dataset.isLoggedIn !== 'true') return;

      var tarotQuotaEl = root.querySelector('#tarotQuota');
      var tarotQuotaValueEl = root.querySelector('#tarotQuotaValue');

      if (!tarotQuotaEl || !tarotQuotaValueEl) return;

      fetch('/apps/backend/get-tarot-quota')
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.success && data.data) {
            tarotQuotaValueEl.textContent = data.data.totalRemainingQuota;
            tarotQuotaEl.style.display = 'block';
          }
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        loadTarotQuota(document);
      });
    } else {
      loadTarotQuota(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      loadTarotQuota(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goddess-space-main-other-quizzes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var QUERY_PARAM = 'other_quiz';

    function updateQuizQuery(quizKey) {
      var url = new URL(window.location.href);
      if (quizKey) {
        url.searchParams.set(QUERY_PARAM, quizKey);
      } else {
        url.searchParams.delete(QUERY_PARAM);
      }
      window.history.replaceState({}, '', url.toString());
    }

    function initQuizCards(scope) {
      var root = scope || document;
      var lists = root.querySelectorAll('.goddess-space__other-quizzes .quiz-list');
      lists.forEach(function (list) {
        if (list.dataset.quizListInit === 'true') return;
        list.dataset.quizListInit = 'true';

        var allQuizContainers = Array.prototype.slice.call(list.querySelectorAll('.quiz-item-container[data-quiz-key]'));

        function closeAllDetails(options) {
          var opts = options || {};
          allQuizContainers.forEach(function (container) {
            var wrapper = container.querySelector('.quiz-card-wrapper[data-quiz-url]');
            var details = wrapper ? wrapper.querySelector('[data-quiz-details]') : null;
            container.classList.remove('is-detail-active');
            if (details) details.hidden = true;
          });
          list.classList.remove('is-detail-mode');

          if (opts.updateUrl) {
            updateQuizQuery('');
          }
        }

        function openDetailForContainer(container, options) {
          var opts = options || {};
          var wrapper = container ? container.querySelector('.quiz-card-wrapper[data-quiz-url]') : null;
          var details = wrapper ? wrapper.querySelector('[data-quiz-details]') : null;
          var resultCard = container ? container.querySelector('.quiz-result-card') : null;
          if (!wrapper || !details) return;

          closeAllDetails({ updateUrl: false });

          if (resultCard && resultCard.style.display !== 'none') {
            if (resultCard.id) {
              container.dataset.returnResultCardId = resultCard.id;
            }
            resultCard.style.display = 'none';
          }

          if (wrapper.style.display === 'none') {
            wrapper.style.display = 'block';
          }

          list.classList.add('is-detail-mode');
          container.classList.add('is-detail-active');
          details.hidden = false;

          if (opts.updateUrl) {
            updateQuizQuery(container.dataset.quizKey || '');
          }

          if (opts.scrollIntoView) {
            window.requestAnimationFrame(function () {
              details.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          }
        }

        function syncFromQuery() {
          var queryQuizKey = new URLSearchParams(window.location.search).get(QUERY_PARAM);
          if (!queryQuizKey) {
            closeAllDetails({ updateUrl: false });
            return;
          }

          var targetContainer = allQuizContainers.find(function (container) {
            return container.dataset.quizKey === queryQuizKey;
          });

          if (!targetContainer) {
            closeAllDetails({ updateUrl: false });
            return;
          }

          openDetailForContainer(targetContainer, { updateUrl: false, scrollIntoView: false });
        }

        var introCards = list.querySelectorAll('.quiz-card-wrapper[data-quiz-url]');
        introCards.forEach(function (card) {
          var url = card.dataset.quizUrl;
          var summary = card.querySelector('[data-quiz-summary]');
          var details = card.querySelector('[data-quiz-details]');
          var startButton = card.querySelector('[data-quiz-action="start"]');
          var backButton = card.querySelector('[data-quiz-action="back"]');
          var shareButton = card.querySelector('[data-quiz-action="share"]');
          if (!summary || !details) return;

          summary.addEventListener('click', function () {
            openDetailForContainer(card.parentElement, { updateUrl: true, scrollIntoView: true });
          });

          if (backButton) {
            backButton.addEventListener('click', function (event) {
              event.preventDefault();
              var itemContainer = card.parentElement;
              var returnResultCardId = itemContainer ? itemContainer.dataset.returnResultCardId : '';

              closeAllDetails({ updateUrl: true });

              if (returnResultCardId) {
                var resultCard = document.getElementById(returnResultCardId);
                if (resultCard) {
                  card.style.display = 'none';
                  resultCard.style.display = 'block';
                }
                if (itemContainer) {
                  delete itemContainer.dataset.returnResultCardId;
                }
                return;
              }

              if (itemContainer) {
                var fallbackResultCard = itemContainer.querySelector('.quiz-result-card');
                if (fallbackResultCard && fallbackResultCard.dataset.reportUrl) {
                  card.style.display = 'none';
                  fallbackResultCard.style.display = 'block';
                }
              }
            });
          }

          if (startButton) {
            startButton.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              if (url) {
                window.location.href = url;
              }
            });
          }

          if (shareButton) {
            shareButton.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();

              var itemContainer = card.parentElement;
              var quizKey = itemContainer ? itemContainer.dataset.quizKey : '';
              var detailTitleEl = card.querySelector('.quiz-card__details-title');
              var detailTitle = detailTitleEl ? detailTitleEl.textContent.trim() : 'Other Quiz';
              var shareUrl = new URL(window.location.href);
              if (quizKey) {
                shareUrl.searchParams.set(QUERY_PARAM, quizKey);
              }
              var shareUrlString = shareUrl.toString();

              if (navigator.share) {
                navigator
                  .share({
                    title: detailTitle,
                    text: detailTitle,
                    url: shareUrlString
                  })
                  .catch(function () {});
                return;
              }

              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard
                  .writeText(shareUrlString)
                  .then(function () {
                    var originalContent = shareButton.innerHTML;
                    shareButton.textContent = 'Copied';
                    window.setTimeout(function () {
                      shareButton.innerHTML = originalContent;
                    }, 1000);
                  })
                  .catch(function () {});
              }
            });
          }
        });

        syncFromQuery();
        window.addEventListener('popstate', syncFromQuery);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initQuizCards(document);
      });
    } else {
      initQuizCards(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initQuizCards(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hash-router"] && !Shopify.designMode) return;
  try {
    
(() => {
  const state = (window.__shopifyHashRouterState ||= {
    listenersBound: false,
    routers: [],
  });

  const cssEscape = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  };

  const normalizeRoute = (hash) => {
    let route = String(hash || '').replace(/^#/, '');
    if (route.startsWith('!')) route = route.slice(1);
    if (route.startsWith('/')) route = route.slice(1);
    route = route.split('?')[0].split('&')[0];
    try {
      route = decodeURIComponent(route);
    } catch {
      // noop
    }
    return route.trim();
  };

  const parseTargetIds = (raw) => {
    return String(raw || '')
      .split(/[\n,]+/)
      .map((value) => value.trim())
      .filter(Boolean);
  };

  const findSectionElements = (targetId) => {
    const targetIds = parseTargetIds(targetId);
    const elements = [];

    for (const rawTarget of targetIds) {
      let value = rawTarget;
      if (value.startsWith('#')) value = value.slice(1);

      if (!value) continue;

      const byExactId = document.getElementById(value);
      if (byExactId) {
        elements.push(byExactId);
        continue;
      }

      const byWrapperId = document.getElementById(`shopify-section-${value}`);
      if (byWrapperId) {
        elements.push(byWrapperId);
        continue;
      }

      const escapedValue = cssEscape(value);
      if (value.includes('__')) {
        document
          .querySelectorAll(`[id^="shopify-section-"][id$="${escapedValue}"]`)
          .forEach((el) => elements.push(el));
        continue;
      }

      const suffix = cssEscape(`__${value}`);
      document
        .querySelectorAll(`[id^="shopify-section-"][id$="${suffix}"]`)
        .forEach((el) => elements.push(el));
    }

    return Array.from(new Set(elements));
  };

  const rememberOriginalDisplay = (element) => {
    if (!element || element.dataset.hashRouterOriginalDisplay) return;

    const inlineDisplay = element.style.display;
    if (inlineDisplay) {
      element.dataset.hashRouterOriginalDisplay = inlineDisplay;
      return;
    }

    const computed = window.getComputedStyle(element).display;
    element.dataset.hashRouterOriginalDisplay = `__computed__${computed}`;
  };

  const restoreDisplay = (element) => {
    if (!element) return;
    const original = element.dataset.hashRouterOriginalDisplay || '';

    if (original.startsWith('__computed__')) {
      element.style.display = original.replace('__computed__', '') || '';
      return;
    }

    element.style.display = original || '';
  };

  const setHidden = (element, hidden) => {
    if (!element) return;

    rememberOriginalDisplay(element);

    if (hidden) {
      element.style.display = 'none';
      element.dataset.hashRouterHidden = 'true';

      element.querySelectorAll('[data-gs-route-view]').forEach((child) => {
        rememberOriginalDisplay(child);
        child.style.display = 'none';
      });
      return;
    }

    restoreDisplay(element);
    delete element.dataset.hashRouterHidden;

    element.querySelectorAll('[data-gs-route-view]').forEach((child) => {
      const original = child.dataset.hashRouterOriginalDisplay || '';
      if (original === '__computed__none' || original === 'none') {
        child.style.display = '';
        return;
      }

      restoreDisplay(child);

      if (child.style.display === 'none') child.style.display = '';
    });
  };

  const registerRouters = () => {
    document.querySelectorAll('[data-hash-router-root]').forEach((root) => {
      if (root.dataset.hashRouterInitialized === 'true') return;

      const configEl = root.querySelector('[data-hash-router-config]');
      if (!configEl) return;

      let config;
      try {
        config = JSON.parse(configEl.textContent);
      } catch {
        return;
      }

      state.routers.push({ root, config });
      root.dataset.hashRouterInitialized = 'true';
    });
  };

  const applyRouter = ({ root, config }) => {
    const mappings = Array.isArray(config?.mappings) ? config.mappings : [];
    const activeMappings = mappings
      .filter((m) => m && typeof m.targetId === 'string' && m.targetId.trim().length > 0)
      .map((m) => ({ route: String(m.route || ''), targetId: String(m.targetId) }));

    const allTargets = () => {
      const all = [];
      for (const mapping of activeMappings) all.push(...findSectionElements(mapping.targetId));
      return Array.from(new Set(all));
    };

    const targetsForRoute = (route) => {
      const all = [];
      for (const mapping of activeMappings) {
        if (normalizeRoute(mapping.route) === route) {
          all.push(...findSectionElements(mapping.targetId));
        }
      }
      return Array.from(new Set(all));
    };

    const routerWrapper = root?.closest?.('[id^="shopify-section-"]') || null;
    const rawRoute = normalizeRoute(window.location.hash);
    const defaultRoute = normalizeRoute(config?.defaultRoute || '');
    const activeRoute = rawRoute || defaultRoute;

    const routeTargets = activeRoute ? targetsForRoute(activeRoute) : [];
    const isMappedRoute = activeRoute !== '' && routeTargets.length > 0;
    const useMainView = !isMappedRoute;

    const allSections = Array.from(document.querySelectorAll('main#content .shopify-section'));

    const toSection = (el) => {
      if (!el) return null;
      if (el.classList && el.classList.contains('shopify-section')) return el;
      return el.closest ? el.closest('.shopify-section') : null;
    };

    const routeSectionsForRoute = Array.from(
      new Set(targetsForRoute(activeRoute).map(toSection).filter(Boolean))
    ).filter((sectionEl) => sectionEl !== routerWrapper);

    const mappedSections = Array.from(new Set(allTargets().map(toSection).filter(Boolean))).filter(
      (sectionEl) => sectionEl && sectionEl !== routerWrapper
    );

    const mainSections = allSections.filter(
      (sectionEl) => sectionEl !== routerWrapper && !mappedSections.includes(sectionEl)
    );

    const resolvedTargets = useMainView ? mainSections : routeSectionsForRoute;
    const everything = Array.from(new Set([...mappedSections, ...mainSections]));
    const visibleSet = new Set(resolvedTargets);

    for (const element of everything) setHidden(element, !visibleSet.has(element));

    if (config?.scrollToTop && !useMainView && routeTargets.length > 0) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const applyAll = () => {
    registerRouters();
    state.routers.forEach(applyRouter);
  };

  if (!state.listenersBound) {
    window.addEventListener('hashchange', applyAll);
    window.addEventListener('popstate', applyAll);
    document.addEventListener('shopify:section:load', applyAll);
    document.addEventListener('shopify:section:reorder', applyAll);
    state.listenersBound = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-comments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-mo-comments-root]');
    if (!roots || !roots.length) return;

    var mobileMq = null;
    try {
      mobileMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    } catch (e) {
      mobileMq = null;
    }

    function toDate(value) {
      if (!value) return null;
      var d = new Date(value);
      if (String(d) === 'Invalid Date') return null;
      return d;
    }

    function byCreatedAt(sort) {
      var dir = sort === 'oldest' ? 1 : -1;
      return function (a, b) {
        var da = toDate(a.created_at);
        var db = toDate(b.created_at);
        var ta = da ? da.getTime() : 0;
        var tb = db ? db.getTime() : 0;
        if (ta === tb) return 0;
        return ta > tb ? dir : -dir;
      };
    }

    function getInitial(name) {
      if (!name) return '?';
      var s = String(name).trim();
      if (!s) return '?';
      return s.slice(0, 1).toUpperCase();
    }

    function setText(el, text) {
      if (!el) return;
      el.textContent = text == null ? '' : String(text);
    }

    function isMobile() {
      return mobileMq ? mobileMq.matches : false;
    }

    roots.forEach(function (root) {
      if (root.dataset && root.dataset.moCommentsInit === '1') return;
      if (root.dataset) root.dataset.moCommentsInit = '1';

      var listEl = root.querySelector('[data-list]');
      var statusEl = root.querySelector('[data-status]');
      var countEl = root.querySelector('[data-count]');
      var sortEl = root.querySelector('[data-sort]');

      var navEl = root.querySelector('[data-nav]');
      var backBtn = root.querySelector('[data-back]');
      var navTitle = root.querySelector('[data-nav-title]');
      var fullBtn = root.querySelector('[data-full-thread]');

      var form = root.querySelector('[data-form]');
      var fatherIdInput = root.querySelector('[data-father-id]');
      var replyingBox = root.querySelector('[data-replying]');
      var replyingText = root.querySelector('[data-replying-text]');
      var cancelReplyBtn = root.querySelector('[data-cancel-reply]');

      var endpoint = root.getAttribute('data-endpoint') || '';
      var pageKey = root.getAttribute('data-page-key') || '';
      var requireLogin = root.getAttribute('data-require-login') === 'true';
      var allowReplies = root.getAttribute('data-allow-replies') === 'true';
      var onlyApproved = root.getAttribute('data-only-approved') === 'true';
      var customerId = root.getAttribute('data-customer-id') || '';

      var state = {
        sort: (root.getAttribute('data-default-sort') || 'newest') === 'oldest' ? 'oldest' : 'newest',
        comments: [],
        byId: {},
        children: {},
        stack: []
      };

      if (sortEl) sortEl.value = state.sort;

      function setStatus(message) {
        setText(statusEl, message || '');
      }

      function setCount(n) {
        if (!countEl) return;
        countEl.hidden = false;
        setText(countEl, n + (n === 1 ? ' comment' : ' comments'));
      }

      function setReplyTo(commentId) {
        if (!fatherIdInput) return;
        fatherIdInput.value = commentId || '0';
        if (!replyingBox) return;
        if (commentId && commentId !== '0') {
          replyingBox.hidden = false;
          var target = state.byId && state.byId[commentId] ? state.byId[commentId] : null;
          var name = target && target.customer_name ? String(target.customer_name) : '';
          setText(replyingText, 'Replying to: ' + (name || commentId));
        } else {
          replyingBox.hidden = true;
          setText(replyingText, '');
        }
      }

      function buildIndex(comments) {
        var byId = {};
        var children = {};
        comments.forEach(function (c) {
          byId[c.comment_id] = c;
          var parentId = c.father_id || '0';
          if (!children[parentId]) children[parentId] = [];
          children[parentId].push(c);
        });
        Object.keys(children).forEach(function (k) {
          children[k].sort(byCreatedAt(state.sort));
        });
        state.byId = byId;
        state.children = children;

        state._descMemo = {};
        state._descVisiting = {};
      }

      function clearList() {
        if (!listEl) return;
        while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
      }

      function el(tag, className) {
        var node = document.createElement(tag);
        if (className) node.className = className;
        return node;
      }

      function renderCommentItem(c, opts) {
        var article = el('article', 'mo-comment');
        article.setAttribute('role', 'listitem');
        article.setAttribute('data-comment-id', c.comment_id);

        var avatar = el('div', 'mo-comment__avatar');
        if (c.avatar_url) {
          var img = document.createElement('img');
          img.src = c.avatar_url;
          img.alt = (c.customer_name || 'Guest') + ' avatar';
          img.loading = 'lazy';
          img.decoding = 'async';
          avatar.appendChild(img);
        } else {
          setText(avatar, getInitial(c.customer_name));
        }
        article.appendChild(avatar);

        var body = el('div', 'mo-comment__body');

        var meta = el('div', 'mo-comment__meta');
        var author = el('span', 'mo-comment__author');
        setText(author, c.customer_name || 'Guest');
        meta.appendChild(author);

        if (c.father_id && c.father_id !== '0' && state.byId && state.byId[c.father_id]) {
          var parent = state.byId[c.father_id];
          var parentName = parent && parent.customer_name ? String(parent.customer_name) : '';
          if (parentName) {
            var replyTo = el('span', 'mo-comment__replyto');
            setText(replyTo, '↳ ' + parentName);
            meta.appendChild(replyTo);
          }
        }

        var created = toDate(c.created_at);
        if (created) {
          var time = el('time', 'mo-comment__time');
          time.dateTime = created.toISOString();
          setText(time, created.toLocaleString());
          meta.appendChild(time);
        }
        body.appendChild(meta);

        var content = el('div', 'mo-comment__content');
        setText(content, c.content || '');
        body.appendChild(content);

        var actions = el('div', 'mo-comment__actions');

        if (allowReplies && opts && opts.showReply) {
          var replyBtn = el('button', 'mo-comment__link');
          replyBtn.type = 'button';
          replyBtn.setAttribute('data-reply-to', c.comment_id);
          setText(replyBtn, 'Reply');
          actions.appendChild(replyBtn);
        }

        function descendantCount(id) {
          if (!state._descMemo) state._descMemo = {};
          if (state._descMemo[id] != null) return state._descMemo[id];
          if (!state._descVisiting) state._descVisiting = {};
          if (state._descVisiting[id]) return 0;
          state._descVisiting[id] = true;

          var kids = (state.children[id] || []);
          var total = kids.length;
          for (var i = 0; i < kids.length; i++) {
            total += descendantCount(kids[i].comment_id);
          }

          state._descVisiting[id] = false;
          state._descMemo[id] = total;
          return total;
        }

        var replyCount = descendantCount(c.comment_id);
        if (opts && opts.showOpenThread && replyCount > 0) {
          var openBtn = el('button', 'mo-comment__link');
          openBtn.type = 'button';
          openBtn.setAttribute('data-open-thread', c.comment_id);
          setText(openBtn, replyCount + (replyCount === 1 ? ' reply' : ' replies'));
          actions.appendChild(openBtn);
        }

        body.appendChild(actions);
        article.appendChild(body);
        return article;
      }

      function renderTreeLevel(parentId, depth) {
        var frag = document.createDocumentFragment();
        var items = (state.children[parentId] || []).slice().sort(byCreatedAt(state.sort));
        var maxDepth = 8;

        items.forEach(function (c) {
          var wrap = el('div', 'mo-thread__item');
          wrap.appendChild(renderCommentItem(c, { showReply: true, showOpenThread: depth >= maxDepth }));
          var childCount = (state.children[c.comment_id] || []).length;
          if (childCount > 0 && depth < maxDepth) {
            var childrenWrap = el('div', 'mo-thread__children');
            childrenWrap.appendChild(renderTreeLevel(c.comment_id, depth + 1));
            wrap.appendChild(childrenWrap);
          }
          frag.appendChild(wrap);
        });

        return frag;
      }

      function renderTreeView() {
        clearList();
        if (navEl) navEl.hidden = true;
        setReplyTo('0');
        state.stack = [];

        var roots = (state.children['0'] || []).slice().sort(byCreatedAt(state.sort));
        if (!roots.length) {
          var empty = el('div', 'mo-comments__empty');
          empty.style.padding = '16px';
          empty.style.color = 'var(--mo-muted)';
          setText(empty, 'No comments yet.');
          if (listEl) listEl.appendChild(empty);
          return;
        }

        var container = el('div', 'mo-thread');
        container.appendChild(renderTreeLevel('0', 0));
        if (listEl) listEl.appendChild(container);
      }

      function renderRootMobile() {
        clearList();
        if (navEl) navEl.hidden = true;
        setReplyTo('0');
        state.stack = [];

        var roots = (state.children['0'] || []).slice().sort(byCreatedAt(state.sort));
        if (!roots.length) {
          var empty = el('div', 'mo-comments__empty');
          empty.style.padding = '16px';
          empty.style.color = 'var(--mo-muted)';
          setText(empty, 'No comments yet.');
          if (listEl) listEl.appendChild(empty);
          return;
        }

        roots.forEach(function (c) {
          if (!listEl) return;
          listEl.appendChild(renderCommentItem(c, { showReply: true, showOpenThread: true }));
        });
      }

      function renderThreadView(focusId) {
        clearList();
        if (navEl) navEl.hidden = false;

        var focus = state.byId[focusId];
        if (navTitle) {
          setText(
            navTitle,
            focus ? ('Comment thread: ' + (focus.customer_name || 'Guest')) : 'Comment thread'
          );
        }

        if (focus && focus.comment_id) {
          setReplyTo(focus.comment_id);
        } else {
          setReplyTo('0');
        }

        if (listEl) {
          var thread = el('div', 'mo-thread');

          if (focus) {
            var wrap = el('div', 'mo-thread__item');
            wrap.appendChild(renderCommentItem(focus, { showReply: true, showOpenThread: false }));

            var childCount = (state.children[focusId] || []).length;
            if (childCount > 0) {
              var childrenWrap = el('div', 'mo-thread__children');
              childrenWrap.appendChild(renderTreeLevel(focusId, 1));
              wrap.appendChild(childrenWrap);
            }

            thread.appendChild(wrap);
          } else {
            thread.appendChild(renderTreeLevel(focusId, 1));
          }

          listEl.appendChild(thread);
        }
      }

      function render() {
        if (!listEl) return;
        if (state.stack.length) {
          renderThreadView(state.stack[state.stack.length - 1]);
          return;
        }
        if (isMobile()) {
          renderRootMobile();
          return;
        }
        renderTreeView();
      }

      function withQuery(url, params) {
        var u = new URL(url, window.location.origin);
        Object.keys(params).forEach(function (k) {
          if (params[k] == null) return;
          u.searchParams.set(k, String(params[k]));
        });
        return u.toString();
      }

      function load() {
        if (!endpoint) {
          setStatus('Missing endpoint (submit_endpoint).');
          return Promise.resolve();
        }
        setStatus('Loading...');
        var url = withQuery(endpoint, {
          page_key: pageKey,
          only_approved: onlyApproved ? 'true' : 'false'
        });
        return fetch(url, { method: 'GET' })
          .then(function (res) {
            if (!res.ok) throw new Error('http_' + res.status);
            return res.json().catch(function () { return {}; });
          })
          .then(function (data) {
            if (data && data.ok === false) throw new Error(data.error || 'load_failed');
            state.comments = (data && data.comments) ? data.comments : [];
            buildIndex(state.comments);
            setCount(state.comments.length);
            setStatus('');
            render();
          })
          .catch(function (err) {
            setStatus('Failed to load: ' + (err && err.message ? err.message : 'unknown'));
          });
      }

      if (sortEl) {
        sortEl.addEventListener('change', function () {
          state.sort = sortEl.value === 'oldest' ? 'oldest' : 'newest';
          buildIndex(state.comments);
          render();
        });
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          state.stack.pop();
          render();
        });
      }

      if (fullBtn) {
        fullBtn.addEventListener('click', function () {
          state.stack = [];
          render();
        });
      }

      if (cancelReplyBtn) {
        cancelReplyBtn.addEventListener('click', function () {
          setReplyTo('0');
        });
      }

      root.addEventListener('click', function (e) {
        var target = e && e.target && e.target.closest ? e.target.closest('[data-open-thread],[data-reply-to]') : null;
        if (!target) return;

        var openId = target.getAttribute('data-open-thread');
        if (openId) {
          state.stack.push(openId);
          render();
          return;
        }

        var replyTo = target.getAttribute('data-reply-to');
        if (replyTo) {
          setReplyTo(replyTo);
          var textarea = form ? form.querySelector('[name="content"]') : null;
          if (textarea && textarea.focus) textarea.focus();
        }
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (requireLogin && !customerId) {
            setStatus('Please log in to comment.');
            return;
          }
          if (!endpoint) {
            setStatus('Missing endpoint (submit_endpoint).');
            return;
          }

          var contentEl = form.querySelector('[name="content"]');
          var content = contentEl ? contentEl.value : '';
          if (!content || !String(content).trim()) {
            setStatus('Please enter a comment.');
            return;
          }

          var payload = {
            page_key: pageKey,
            content: String(content).trim(),
            father_id: fatherIdInput ? fatherIdInput.value : '0'
          };

          setStatus('Submitting...');
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(function (res) {
              if (!res.ok) throw new Error('http_' + res.status);
              return res.json().catch(function () { return {}; });
            })
            .then(function (data) {
              if (data && data.ok === false) throw new Error(data.error || 'submit_failed');
              if (contentEl) contentEl.value = '';
              setReplyTo('0');
              return load();
            })
            .catch(function (err) {
              setStatus('Submit failed: ' + (err && err.message ? err.message : 'unknown'));
            });
        });
      }

      load();

      if (mobileMq) {
        var handler = function () {
          if (!state.stack.length) render();
        };
        if (mobileMq.addEventListener) mobileMq.addEventListener('change', handler);
        else if (mobileMq.addListener) mobileMq.addListener(handler);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
